import createAsyncThunkFromFetch from '../../store/middlewares/createAsyncThunkFromFetch';
import {
  getCompanyPaymentProvider,
  getCompanyPaymentProviders,
  postNewCompanyPaymentProvider,
  updateCompanyPaymentProvider as updateCompanyPaymentProviderAPI,
  deleteCompanyPaymentProvider as deleteCompanyPaymentProviderAPI,
  updateCompanyPaymentMethods as updateCompanyPaymentMethodsAPI,
  getPaymentMethods,
} from './paymentProvider.api';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { CompanyPaymentProvider } from './paymentProvider.types';
import { fetchCompany } from '../companies/companies.state';

const name = 'paymentProvider';

export const fetchCompanyPaymentProviders = createAsyncThunkFromFetch(
  `${name}/fetchCompanyPaymentProviders`,
  getCompanyPaymentProviders
);

export const fetchCompanyPaymentProvider = createAsyncThunkFromFetch(
  `${name}/fetchCompanyPaymentProvider`,
  getCompanyPaymentProvider
);

export const createCompanyPaymentProvider = createAsyncThunkFromFetch(
  `${name}/createCompanyPaymentProvider`,
  postNewCompanyPaymentProvider
);

export const updateCompanyPaymentProvider = createAsyncThunkFromFetch(
  `${name}/updateCompanyPaymentProvider`,
  updateCompanyPaymentProviderAPI
);

export const deleteCompanyPaymentProvider = createAsyncThunkFromFetch(
  `${name}/deleteCompanyPaymentProvider`,
  deleteCompanyPaymentProviderAPI
);

export const updateCompanyPaymentMethods = createAsyncThunkFromFetch(
  `${name}/updateCompanyPaymentMethods`,
  updateCompanyPaymentMethodsAPI
);

export const fetchPaymentMethods = createAsyncThunkFromFetch(`${name}/fetchPaymentMethods`, getPaymentMethods);

const paymentProviderAdapter = createEntityAdapter<CompanyPaymentProvider>({
  selectId: provider => provider.id,
});

export const paymentProviderSelectors = paymentProviderAdapter.getSelectors();

const paymentProviderSlice = createSlice({
  name,
  initialState: paymentProviderAdapter.getInitialState<{
    companyProviders: Record<string, string>;
    paymentMethods: string[];
    companyPaymentMethods: Record<string, string[]>;
  }>({
    companyProviders: {},
    paymentMethods: [],
    companyPaymentMethods: {},
  }),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchCompanyPaymentProviders.fulfilled, (state, { payload, meta }) => {
      const { companyId } = meta.arg;
      paymentProviderAdapter.upsertOne(state, payload);
      state.companyProviders[companyId] = payload.id;
    });
    builder.addCase(fetchCompanyPaymentProvider.fulfilled, (state, { payload, meta }) => {
      const { companyId } = meta.arg;
      paymentProviderAdapter.upsertOne(state, payload);
      state.companyProviders[companyId] = payload.id;
    });
    builder.addCase(createCompanyPaymentProvider.fulfilled, (state, { payload, meta }) => {
      const { companyId } = meta.arg;
      paymentProviderAdapter.addOne(state, payload);
      state.companyProviders[companyId] = payload.id;
    });
    builder.addCase(updateCompanyPaymentProvider.fulfilled, (state, { payload }) => {
      paymentProviderAdapter.upsertOne(state, payload);
    });
    builder.addCase(deleteCompanyPaymentProvider.fulfilled, (state, { meta }) => {
      const { companyId } = meta.arg;
      paymentProviderAdapter.removeOne(state, meta.arg.providerId);
      delete state.companyProviders[companyId];
    });
    builder.addCase(fetchPaymentMethods.fulfilled, (state, { payload }) => {
      state.paymentMethods = payload;
    });
    builder.addCase(updateCompanyPaymentMethods.fulfilled, (state, { payload, meta }) => {
      const { companyId } = meta.arg;
      state.companyPaymentMethods[companyId] = payload;
    });
    builder.addCase(fetchCompany.fulfilled, (state, { payload, meta }) => {
      const { companyId } = meta.arg;
      state.companyPaymentMethods[companyId] = payload.paymentMethods;
    });
  },
});

const { reducer } = paymentProviderSlice;

export default reducer;
